import { useAppConfigContext } from '../../../contexts/AppConfigProvider';
import { useUser } from '../../../hooks/useUser';

/**
 * The service provider metadata URL an admin imports into their own identity
 * provider. Auth0 serves it per connection, so it is derived, not fetched: host
 * per stage/region from config, connection name from the provider. Pure, so the
 * format is testable — a wrong value surfaces only as a broken sign-in, long
 * after the mistake.
 */
export const buildSpMetadataUrl = (
    auth0Domain: string | undefined,
    connectionName: string | undefined,
): string | undefined => {
    if (!auth0Domain || !connectionName) return undefined;
    return `https://${auth0Domain}/samlp/metadata?connection=${encodeURIComponent(
        connectionName,
    )}`;
};

/**
 * Resolves the host as the sign-in flow does, from `uas.config.auth0Clients`
 * keyed by region, rather than a hostname wrong in every stage but production.
 */
export const useSpMetadataUrl = (
    connectionName: string | undefined,
): string | undefined => {
    const { uas } = useAppConfigContext();
    const user = useUser();
    const region = user?.region;
    const domain = region
        ? uas?.config?.auth0Clients?.[region]?.domain
        : undefined;
    return buildSpMetadataUrl(domain, connectionName);
};
